export default __webpack_public_path__ + "static/Macaron_Cake_2020-06-12_7497-88427e479bba88ea8fdf62a24c4f947c.jpg";